/**
 * @typedef {(BUTTON | DOOR | GROUND | HERO | INTERACTION | KING | LOGIC_GATE_AND | PAWN | TIMER_1000 | ZONE)} TypeEntity An entity.
 */

/**
 * The 'BUTTON' entity.
 * @type {'BUTTON'}
 * @constant
 */
const BUTTON = 'BUTTON';

/**
 * The 'DOOR' entity.
 * @type {'DOOR'}
 * @constant
 */
const DOOR = 'DOOR';

/**
 * The 'GROUND' entity.
 * @type {'GROUND'}
 * @constant
 */
const GROUND = 'GROUND';

/**
 * The 'HERO' entity.
 * @type {'HERO'}
 * @constant
 */
const HERO = 'HERO';

/**
 * The 'INTERACTION' entity.
 * @type {'INTERACTION'}
 * @constant
 */
const INTERACTION = 'INTERACTION';

/**
 * The 'KING' entity.
 * @type {'KING'}
 * @constant
 */
const KING = 'KING';

/**
 * The 'LOGIC_GATE_AND' entity.
 * @type {'LOGIC_GATE_AND'}
 * @constant
 */
const LOGIC_GATE_AND = 'LOGIC_GATE_AND';

/**
 * The 'PAWN' entity.
 * @type {'PAWN'}
 * @constant
 */
const PAWN = 'PAWN';

/**
 * The 'TIMER_1000' entity.
 * @type {'TIMER_1000'}
 * @constant
 */
const TIMER_1000 = 'TIMER_1000';

/**
 * The 'ZONE' entity.
 * @type {'ZONE'}
 * @constant
 */
const ZONE = 'ZONE';

export {

    BUTTON,
    DOOR,
    GROUND,
    HERO,
    INTERACTION,
    KING,
    LOGIC_GATE_AND,
    PAWN,
    TIMER_1000,
    ZONE
};
